import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import LandingPage from './component/LandingPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LandingPage />
);


